export const getUniqueValue = (data, type) => {
  let uniqueValue = data.map((product) => product[type]);

  return (uniqueValue = ['all', ...new Set(uniqueValue)]);
};
